<!--  -->
<template>
  <div class="register">
    <div class="view-wrapper">
      <div class="header color-w">
        <img class="logo" src="../assets/imgs/sr-logo.png" alt />
      </div>
      <div class="form">
        <div class="item item-relative">
          <input class="font-l" type="text" placeholder="请选择所在店铺" v-model="shop.name" />
          <div class="item-mask" @click="togglePopup"></div>
        </div>
        <div class="item">
          <input
            class="font-l"
            v-model="userName"
            placeholder="请输入店员账号"
            ref="input0"
            @focus="inputFocus(0)"
            @blur="inputBlur"
          />
        </div>
        <div class="item">
          <input
            class="font-l"
            type="password"
            v-model="passWord"
            placeholder="请输入店员密码"
            ref="input1"
            @focus="inputFocus(1)"
            @blur="inputBlur"
          />
        </div>

        <div class="item query font-l" @click="login">立即登录</div>
      </div>
    </div>
    <mt-popup
      v-model="popupVisible"
      popup-transition="popup-fade"
      position="bottom"
      style="width: 100%"
    >
      <transition name="slide">
        <div class="self-picker" v-show="popupVisible">
          <div class="picker-tool border-1px">
            <div>
              <span @click="togglePopup">取消</span>
            </div>
            <div>
              <span @click="queryPopup">确定</span>
            </div>
          </div>
          <mt-picker :slots="slots" valueKey="name" @change="onValuesChange"></mt-picker>
        </div>
      </transition>
    </mt-popup>
  </div>
</template>

<script>
import api from "../assets/js/api.js";
import util from "../assets/js/util.js";
var that;
export default {
  data() {
    return {
      userName: "",
      passWord: "",
      shop: {
        id: null,
        name: ""
      },
      popupVisible: false,
      slots: [
        {
          flex: 1,
          values: [{ id: "", name: "请选择所在门店" }],
          className: "slot1",
          textAlign: "center"
        }
      ]
    };
  },

  components: {},

  computed: {},
  created() {
    that = this;
    that.shops();
  },

  mounted() {},

  methods: {
    login() {
      if (that.shop.id == null || that.shop.id == "") {
        that.$toast({ message: "请选择所在门店", duration: 2000 });
        return;
      }
      if (that.userName === "") {
        that.$toast({ message: "请输入店员账号", duration: 2000 });
        return;
      }
      if (that.passWord === "") {
        that.$toast({ message: "请输入店员密码", duration: 2000 });
        return;
      }

      this.$http
        .post(api.clerkLogin, {
          openId: util.getss("openId"),
          userName: that.userName,
          passWord: that.passWord,
          shopId: that.shop.id
        })
        .then(res => {
          if (res.code === util.ERR_OK) {
            util.setss("token", res.data.token);
            util.setss("clerkMsg", JSON.stringify(res.data.apiClerk));
            that.$router.replace({ path: "./scan" });
          } else {
            that.$toast({ message: res.msg, duration: 2000 });
          }
        });
    },
    //获取店铺信息
    shops() {
      that.$http.get(api.getShops, {}).then(res => {
        if (res.code === util.ERR_OK) {
          that.slots[0].values = that.slots[0].values.concat(res.data);
        }
      });
    },
    togglePopup() {
      that.popupVisible = !that.popupVisible;
    },
    onValuesChange(picker, values) {
      that.readyShop = values[0];
    },
    queryPopup() {
      that.shop = that.readyShop;
      that.popupVisible = false;
    },
    inputFocus(e) {
      setTimeout(() => {
        that.$refs[`input${e}`].scrollIntoViewIfNeeded();
      }, 400);
    },
    inputBlur() {
      window.scrollTo(0, 0);
    }
  }
};
</script>
<style lang='stylus' scoped>
.register {
  width: 100vw;
  height: 100vh;
  background: #000000 url('../assets/imgs/bg4.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: 50%;

  .view-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    overflow: auto;

    .header {
      padding: unit(300px) 0 unit(86px);
      font-size: unit(100px);
      text-align: center;

      .logo {
        width: unit(200rpx);
        height: unit(200rpx);
      }
    }

    /* 填写 */
    .form {
      width: unit(555px);
      margin: 0 auto;

      .item {
        width: 100%;
        height: unit(82px);
        background: rgba(245, 245, 245, 0.15);
        border-radius: unit(40px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: unit(40px);

        input {
          flex: 1;
          height: 100%;
          padding: 0 unit(40px) 0;
          color: #666;
          font-size: unit(36px);
        }
      }

      .item-relative {
        position: relative;

        .item-mask {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 10;
        }
      }

      .query {
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--gold);
        color: #fff;
        border: none;
        border-radius: unit(40px);
        margin-top: unit(80px);
      }
    }
  }

  .self-picker {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 60;

    &.slide-enter-active, &.slide-leave-active {
      transition: all 0.5s;
    }

    &.slide-enter, &.slide-leave-active {
      bottom: -220px;
    }

    .picker-tool {
      height: 36px;
      display: flex;
      justify-content: center;
      border: 1px solid #d9d9d9;

      div {
        flex: 1;
        text-align: center;
        line-height: 36px;
        color: var(--gold);
      }
    }
  }
}
</style>